import * as React from 'react';
import './ProjectImages.css';
import { ClassNames } from '../../_helpers/ClassNames';
import Image from '../Image/Image';

export type ProjectImagesProps = ProjectImagesDto;

export class ProjectImages extends React.Component<ProjectImagesProps> {

    constructor(props: ProjectImagesProps) {
        super(props);
    }

    render() {
        const { Images } = this.props;
        return (
            <div className={ClassNames("project-images", "")}>
                {Images.map((image, i) => {
                    const ratio = image.Height / image.Width;
                    const portrait = ratio >= 1;

                    return (
                        <figure
                            key={i}
                            className={ClassNames('project-images', 'figure', portrait ? 'portrait' : 'landscape')}
                        >
                            <Image
                                pictureRef={image}
                                className={ClassNames("project-images", "image")}
                                sizes={portrait ?
                                    `(max-width: 770px) 100vw, 
                                    (min-width: 771px) 800px` :
                                    `(max-width: 1280px) 100vw, 
                                    (min-width: 1281px) 1300px`
                                }
                            />
                        </figure>
                    );
                }
                )}
            </div>
        );
    }
}

export default ProjectImages;


// WEBPACK FOOTER //
// ./src/Components/ProjectImages/ProjectImages.tsx